import styled from 'styled-components'

export const ExistingUserLoginLink = styled.div`
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  font-family: Inter;
`

export const StyledLoginButton = styled.button`
  height: 40px;
  background: ${(props) => {
    return props.background || 'transparent'
  }};
  border-radius: 4px;
  color: ${(props) => {
    return props.color || '#0AA1F4'
  }};
  border: ${(props) => {
    return props.border || '1px solid #0AA1F4'
  }};
  margin-left: 14px;
  padding: 0 24px;
`

export const StyledLangButton = styled.button`
  height: 50px;
  background: ${(props) => {
    return props.background || 'transparent'
  }};
  border-radius: 4px;
  color: ${(props) => {
    return props.color || '#0AA1F4'
  }};
  border: ${(props) => {
    return props.border || 'none'
  }};
 
`

export const TopBarWrapper = styled.nav`
  height: 72px;
  width: 100%;
  display: flex;
  background: white;
  padding-right: 56px;
  padding-left: 56px;
  justify-content: space-between;
  align-items: center;
  border-bottom: ${(p) => {
    return p.noBorder ? 'none' : '1px solid rgba(32, 32, 32, 0.1)'
  }};
  border-left: 1px solid rgba(32, 32, 32, 0.1);
  box-shadow: 1px 0 2px rgba(32, 32, 32, 0.1);
`
export const TopBarUnAuthorizedWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 54px;
  margin-bottom: 24px;
  width: ${(props) => {
    return props.isWhiteColoredHeader ? '47%' : '100%'
  }};
`

export const TopBarLeftSideWrapper = styled.div`
  display: flex;
  height: 100%;
  align-items: center;
`

export const TopBarRightSideWrapper = styled.div`
  display: flex;
  height: 100%;
`

export const TopBarCategoryTitle = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  line-height: 32px;
  font-weight: 600;
  font-family: 'Inter';
`

export const TopBarDotWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 16px;

  > div {
    height: 4px;
    width: 4px;
    background: rgba(32, 32, 32, 0.2);
    border-radius: 50%;
  }
`

export const TopBarCountry = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
  color: rgba(32, 32, 32, 1);
`

export const TopBarRoleWrapper = styled.div`
  height: 24px;
  min-width: 43px;
  width: auto;
  padding-left: 8px;
  padding-right: 8px;
  border-radius: 4px;
  background: rgba(255, 203, 0, 0.5);
  margin-left: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: 'Inter';
  font-size: 12px;
  line-height: 16px;
  font-weight: 500;
  color: rgba(32, 32, 32, 1);
`

export const TopBarProfile = styled.div`
  height: 100%;
  border-left: 1px solid rgba(32, 32, 32, 0.1);
  display: flex;
  align-items: center;
  padding-left: 24px;
`

export const TopBarButtonWrapper = styled.div`
  height: 100%;
  display: flex;
  gap: 16px;
  align-items: center;
  margin-right: 24px;
`

export const HeaderTopBarNotificationWrapper = styled.div`
  height: 100%;
  border-left: 1px solid rgba(32, 32, 32, 0.1);
  display: flex;
  align-items: center;
`
export const StyleSingleDot = styled.div`
margin: 0 17px 0 17px;
`
export const TotalSitesCounterBox = styled.div`
  width: 39px;
  height: 24px;
  font-size: 12px;
  font-weight: 400;
  background-color: rgba(255, 203, 0, 0.5);
  border-radius: 4px; 
  margin-left: 17px;
  display: flex;
  align-items: center;
  justify-content: center;
`
export const Divider = styled.div`
height: 24px;
width: 1px;
background-color: rgba(32,32,32,0.1);
margin: 0 24px 0 24px;
`
export const MySitesCounterWrapper = styled.div`
display: flex;
justify-content: center;
align-items: center;
font-size: 14px;
font-weight: bold;
`
export const SitesFilterItemWrapper = styled.div`
  width: 184px;
  margin-right: 24px;
  border-radius: 4px; 
  margin-top: 0;
`

export const HeaderTotalSitesTextWrapper = styled.div`
  
`
